var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFire2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 54,
    viewBox: "0 0 76 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_df_86_2879)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5018 21.5317C15.0274 16.0268 11.3845 11.913 10.4497 11.7763C12.9789 13.9569 12.9686 21.9672 12.3116 24.6674C11.6546 27.3675 8.25977 30.4161 8.25977 34.7712C9.02636 42.7846 19.5845 46.1374 23.7012 45.9202C18.8826 44.1085 15.5605 39.5328 14.5018 37.4714C14.3138 38.4648 14.677 40.5373 15.3779 42.3491C7.71192 37.994 9.33997 33.1163 10.4497 30.8516C11.3258 35.1719 12.494 36.6584 12.9686 36.8616C13.0416 36.1648 13.2533 34.4402 13.5162 33.1163C16.5826 37.3842 19.5394 35.3809 21.8392 34.7712C21.3882 35.1712 17.3491 37.4714 17.3491 37.4714C17.3491 37.4714 22.3868 39.9973 24.9056 40.9554V36.8616C29.6632 37.4714 33.7388 33.0292 35.7101 33.1163C37.6813 33.2034 45.4942 42.4362 48.6701 39.4747C51.846 36.5132 56.0075 37.0358 56.8837 38.9521C57.7598 40.8683 53.8804 44.3646 52.2841 45.9202C66.9589 41.5651 67.5065 32.5936 67.5065 30.8516C66.9589 31.2871 64.8782 31.6355 63.2355 31.6355C64.2211 22.9253 59.293 19.9639 54.4743 17.1766C49.6557 14.3894 51.4196 9.92371 51.0794 8.46643C48.6701 14.1281 52.1746 16.9153 54.4743 19.3542C56.7741 21.793 58.4168 26.061 54.4743 30.4161C50.5318 34.7712 46.5893 33.1163 44.7276 33.1163C44.2896 35.2938 39.815 31.4613 34.5583 31.6355C29.3016 31.8097 26.2198 35.5551 24.9056 30.4161C23.5914 25.2771 21.7297 23.6222 19.5394 23.6222C21.8392 25.7126 21.7297 32.1581 18.1157 31.6355C14.5018 31.1129 13.8447 28.4128 14.5018 21.5317Z",
    fill: "#FFB62E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_df_86_2879",
    x: 0.464469,
    y: 0.671134,
    width: 74.8367,
    height: 53.0543,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.89765
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.996078 0 0 0 0 0.917647 0 0 0 0 0.447059 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_86_2879"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_86_2879",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.389765,
    result: "effect2_foregroundBlur_86_2879"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire2);
export default __webpack_public_path__ + "static/media/fire2.db5ab90a.svg";
export { ForwardRef as ReactComponent };